import { useRequestURL } from "#imports";
import { getMainDomain } from "./DomainUtils.js";
export function login(callbackUrl, email) {
  if (!process.client) return;
  callbackUrl = callbackUrl || window.location.href;
  const mainDomain = getMainDomain(window.location.host);
  const loginUrl = `https://account.${mainDomain}/login?callback_url=${encodeURIComponent(callbackUrl)}${email ? "&login_hint=" + encodeURIComponent(email) : ""}${email ? "&prompt=login" : ""}`;
  window.location.href = loginUrl;
}
export function getLoginUrl({
  callbackUrl,
  email,
  brandDomain
}) {
  const host = useRequestURL().host;
  const mainDomain = brandDomain || getMainDomain(host);
  const loginUrl = `https://account.${mainDomain}/login?callback_url=${encodeURIComponent(callbackUrl)}${email ? "&login_hint=" + encodeURIComponent(email) : ""}${email ? "&prompt=login" : ""}`;
  return loginUrl;
}
